<template>
  <div class="totals" :class="{ loading: loading }">
    <div v-for="a_amount in amountsList" :key="a_amount.text" class="totals--amount">
      <span class="totals--amount--name gray">{{ a_amount.text }}</span>
      <div class="totals--amount--amount" :class="a_amount.class">
        <span>{{ formatAmount(a_amount.amount) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from "@/utils/";

export default {
  name: "TotalAmountsBase",
  props:{
    numFormat: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      filters: {},
      unsubscribe: null,
      loading: false,
      amountsList: [],
      mutationName: false
    }
  },
  destroyed () {
    this.unsubscribe();
  },
  created () {
    this.debouncedGetTotals = debounce(() => {
      this.getTotalAmounts()
    }, 300)

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      const checkMutation = this.mutationName || 'filterStore/' + this.$parent.mutationName
      if (mutation.type === checkMutation) {
        this.filters = state["filterStore"].filter
        this.debouncedGetTotals()
      }
    });
    this.filters = this.$store.getters['filterStore/getFilter']
    this.debouncedGetTotals()
  },
  methods: {
    getTotalAmounts (){
      console.log("override this function: getTotalAmounts!")
    },
    formatAmount (amount) {
      let formattedAmount = amount
      if(this.numFormat) {
        switch (this.numFormat) {
          case 'euro':
            formattedAmount = "€ " + this.$options.filters.formatNumber(amount)
            break;
          case 'hours':
            formattedAmount = this.$options.filters.amount2HourMin(amount, this.$gettext("H"), this.$gettext("M"))
            break;
          case 'int':
            formattedAmount = parseInt(amount)
            break;
          case 'decimal':
            formattedAmount = amount
        }
      }
      return formattedAmount
    }
  },
};
</script>
<style lang="scss" scoped>
  .gray { color: #777777; }
  // .blue { color: $colorBlue; }
  // .brown { color: $colorBrown; }
  // .black { color: $colorTextBase; }
  .totals {
    // min-height: 50px;
    // min-height: 40px;
    display: flex;
    flex-wrap: wrap;
    transition: opacity 0.2s ease;
    &.loading { opacity: 0.3; }
    &--amount {
      font-family: 'DINNextLTPro-Medium';
      font-size: 20px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      flex-grow: 0;
      flex-direction: column;
      padding-left: 14px;
      line-height: 1;
      white-space: nowrap;
      &--name {
        text-align: right;
        padding-right: 0;
        font-size: 65%;
        text-transform: uppercase;
        margin-bottom: 7px;
      }
      &--amount { line-height: 0.7; }
    }
  }

@media( min-width: '768px' ){
    .totals {
      justify-content: flex-end;
    }
    // .totals--amount {
    //   font-size: 18px;
    // }
  }
  @media (min-width: '992px') {
    .totals--amount {
      font-size: 20px;
    }
  }
</style>